import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { getInstance, getStore } from 'sdk';
import App from './App';
import './index.css';
import './translations/i18n';

// Initialize theme before render to prevent flash
const initTheme = () => {
    const stored = localStorage.getItem('appna-theme') as 'light' | 'dark' | 'system' | null;
    const theme = stored || 'system';
    const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const effectiveTheme = theme === 'system' ? (systemDark ? 'dark' : 'light') : theme;
    
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(effectiveTheme);
    document.documentElement.style.colorScheme = effectiveTheme;
};
initTheme();

// Initialize SDK
getInstance();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Provider store={getStore()}>
            <App />
        </Provider>
    </StrictMode>
);
